/**
 * System Lizard - Web MIDI API & Virtual Keyboard Integration
 */

export class MIDIHandler {
  constructor(synthEngine) {
    this.synth = synthEngine;
    this.midiAccess = null;
    this.activeInputs = new Map();
  }

  async initMIDI() {
    if (!navigator.requestMIDIAccess) {
      console.warn('Web MIDI API not supported in this browser.');
      return false;
    }

    try {
      this.midiAccess = await navigator.requestMIDIAccess();
      this.setupInputs();

      this.midiAccess.onstatechange = () => {
        this.setupInputs();
      };
      return true;
    } catch (err) {
      console.warn('MIDI access denied or error:', err);
      return false;
    }
  }

  setupInputs() {
    if (!this.midiAccess) return;
    const inputs = this.midiAccess.inputs.values();
    for (const input of inputs) {
      if (!this.activeInputs.has(input.id)) {
        input.onmidimessage = (e) => this.handleMIDIMessage(e);
        this.activeInputs.set(input.id, input);
      }
    }
  }

  handleMIDIMessage(event) {
    const [status, note, velocity] = event.data;
    const command = status >> 4;

    if (command === 9 && velocity > 0) {
      // Note On
      this.synth.noteOn(note, velocity / 127);
    } else if (command === 8 || (command === 9 && velocity === 0)) {
      // Note Off
      this.synth.noteOff(note);
    }
  }
}
